export default __webpack_public_path__ + "static/media/add-basket.e0c5d61b.svg";